"use client"

import {SearchSvg} from "@/app/components/icons/SearchSvg";
import {IconBtn} from "@/app/components/common/icon-btn/IconBtn";
import React, {HTMLAttributes} from "react";
import {useOpenDialog} from "@/lib/dialog-orchestrator/react";
import {DialogsEnum} from "@/lib/enums/DialogsEnum";

export default function MobileSearchIconBtn({...props}: HTMLAttributes<HTMLButtonElement>) {
    const openDialog = useOpenDialog();
    return (
        <IconBtn onClick={() => openDialog(DialogsEnum.SEARCH)} size={'lg'} {...props}>
            <SearchSvg/>
        </IconBtn>
    )
}
